import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClose = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgClose" data-sentry-source-file="close.tsx">
    <g clipPath="url(#close_svg__a)" data-sentry-element="g" data-sentry-source-file="close.tsx">
      <path fill="#263E6A" d="m6.4 18.308-.708-.708 5.6-5.6-5.6-5.6.708-.708 5.6 5.6 5.6-5.6.708.708-5.6 5.6 5.6 5.6-.708.708-5.6-5.6z" data-sentry-element="path" data-sentry-source-file="close.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="close.tsx">
      <clipPath id="close_svg__a" data-sentry-element="clipPath" data-sentry-source-file="close.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="close.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgClose;